export default "__VITE_ASSET__CsgadIRB__"